export default "__VITE_ASSET__7d73fb76__"